export default __webpack_public_path__ + "static/media/yellowCircle.62d74f1c.svg";